import { SignOutButton } from "./buttons/signOutButton";

export const Unauthorized = () => {
  return (
    <div>
      <h1>UNAUTHORIZED</h1>
      <p>
        You are not authorized to view this page. Please sign out and login with
        a different account.
      </p>
      <SignOutButton />
    </div>
  );
};
